import type { SxProps, Theme } from "@mui/material/styles";

type AuthStatusCardOptions = {
  textAlign?: "left" | "center";
};

export const authStatusPageSx: SxProps<Theme> = {
  minHeight: { xs: "calc(100vh - 120px)", md: "calc(100vh - 140px)" },
  display: "grid",
  placeItems: "center",
  width: "100%",
  bgcolor: "background.default",
  px: { xs: 2, md: 3 },
  py: { xs: 4, md: 6 },
};

export const routeLoadingPageSx: SxProps<Theme> = {
  ...authStatusPageSx,
  px: 0,
};

export const getAuthStatusCardSx =
  ({ textAlign }: AuthStatusCardOptions = {}): SxProps<Theme> =>
  (theme) => ({
    width: "min(100%, 650px)",
    border: 1,
    borderColor: theme.palette.divider,
    borderRadius: 1,
    p: { xs: 3, md: 4 },
    bgcolor: "background.paper",
    boxShadow: theme.shadows[1],
    ...(textAlign ? { textAlign } : {}),
  });

export const authStatusIconSx: SxProps<Theme> = (theme) => ({
  width: 52,
  height: 52,
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
  color: theme.palette.primary.main,
  bgcolor: "var(--surface-muted)",
  boxShadow: "inset 0 0 0 1px var(--border-light)",
});

export const authStatusContentSx: SxProps<Theme> = {
  alignItems: "center",
  textAlign: "center",
};

export const authStatusProgressSx: SxProps<Theme> = (theme) => ({
  width: "min(100%, 344px)",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 1,
  px: 2,
  py: 1,
  color: "text.secondary",
  bgcolor: "var(--surface-muted)",
});

export const authStatusActionsSx: SxProps<Theme> = {
  justifyContent: "center",
  width: "100%",
};

export const authStatusPrimaryButtonSx: SxProps<Theme> = {
  minWidth: 150,
};

export const authStatusSecondaryButtonSx: SxProps<Theme> = {
  minWidth: 150,
};

export const authStatusHelperSx: SxProps<Theme> = {
  maxWidth: 420,
  mx: "auto",
};
